module.exports = __webpack_public_path__ + "img/basico2.fw.520281aa.png";